import { useTranslation } from 'react-i18next';
import { StringListEditor } from './StringListEditor';
import { parseChoiceOptions, serializeChoiceOptions } from '../../adapters/field-type.adapter';

interface FieldOptionsEditorProps {
  fieldId: string;
  optionsJson: string | null | undefined;
  onChange: (optionsJson: string) => void;
  disabled?: boolean;
}

export function FieldOptionsEditor({
  fieldId,
  optionsJson,
  onChange,
  disabled = false,
}: FieldOptionsEditorProps) {
  const { t } = useTranslation('forms');
  const options = parseChoiceOptions(optionsJson ?? null);

  return (
    <StringListEditor
      idPrefix={fieldId}
      label={t('builder.optionsLabel')}
      values={options}
      onChange={(next) => onChange(serializeChoiceOptions(next))}
      addLabel={t('builder.addOption')}
      deleteLabel={t('builder.deleteOption')}
      testIdPrefix="forms-builder-option"
      disabled={disabled}
    />
  );
}
